import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if(typeof window != 'undefined') 
    	window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
  }, [pathname]);
  return null;
}

